import React from 'react'

const DuplicateIcon = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="34" height="34" rx="17" fill="white"/>
<rect x="0.5" y="0.5" width="34" height="34" rx="17" stroke="#3249D7"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 10.625H12.5C11.8125 10.625 11.25 11.1875 11.25 11.875V20.625H12.5V11.875H20V10.625ZM21.875 13.125H15C14.3125 13.125 13.75 13.6875 13.75 14.375V23.125C13.75 23.8125 14.3125 24.375 15 24.375H21.875C22.5625 24.375 23.125 23.8125 23.125 23.125V14.375C23.125 13.6875 22.5625 13.125 21.875 13.125ZM15 23.125H21.875V14.375H15V23.125Z" fill="#3249D7"/>
</svg>
  )
}

export default DuplicateIcon
